export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            🏷️ 关于我们
          </h2>
        </div>
        <div className="bg-background-100 border border-background-200/60 rounded-2xl p-8 md:p-10">
          <div className="space-y-5 text-sm text-foreground-700 leading-relaxed">
            <p>
              <strong className="text-foreground-950 font-heading text-base">91黑料</strong> 是国内领先的娱乐八卦与热点资讯聚合平台，致力于为广大网友提供最新、最全、最劲爆的黑料内容。自成立以来，我们始终坚持"真实、快速、全面"的内容理念，在行业内建立了良好的口碑与影响力。
            </p>
            <p>
              我们的编辑团队遍布全国各大城市，拥有广泛的业内人脉与信息来源渠道。无论是娱乐圈的明星八卦、网红圈的内幕揭秘，还是社会热点事件的深度挖掘，91黑料都能在第一时间为您呈现最真实的现场还原与最深入的背景分析。
            </p>
            <p>
              目前，91黑料月活跃用户已突破<strong className="text-primary-600">500万</strong>，每日内容更新量超过<strong className="text-primary-600">100条</strong>，累计收录黑料视频<strong className="text-primary-600">2000余部</strong>。我们持续优化平台体验，确保每一位访问者都能快速、安全地获取到所需的资讯内容。
            </p>
            <p>
              未来，91黑料将继续拓展内容深度与广度，在保障信息真实性的前提下，为用户提供更加丰富多元的爆料内容。同时我们也将持续加强平台安全建设，保护每一位用户和爆料人的合法权益。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}